import styles from "./style.module.scss";

import DynamicForm, { DynamicFormRef } from "@mavichpe/dynamic-forms";
import { forwardRef, useEffect, useRef, useState } from "react";
import BuyYearReportFormConfig from "./form";
import { BuyReportFormDataType } from "@/formTypes/BuyReportFormDataType";
import { Button, Col, Row } from "reactstrap";
import { getYearBoundaries } from "@utils/Utils";
import { REPORT_EXCEL_FORMAT, REPORT_PRINT_FORMAT } from "@utils/Constants";

type BuyYearReportFormProps = {
}

const BuyYearReportForm = forwardRef<DynamicFormRef, BuyYearReportFormProps>(
  (props, ref) => {
    const formRef = useRef<DynamicFormRef>(null);

    useEffect(() => {
      const now = new Date();
      const year = now.getFullYear();
      formRef.current?.resetFormValue({
        year
      })
    }, [])

    const getFormConfig = () => {
      return BuyYearReportFormConfig;
    }

    const generateForm = (formData: BuyReportFormDataType) => {
      const { startDate, endDate } = getYearBoundaries(`${formData.year}`, true)

      if (formData.format == REPORT_PRINT_FORMAT) {
        window.open(`/user/reports/print/buyByMonth/${formData.providerId}/${startDate}/${endDate}`, "_blank")
      } else if (formData.format == REPORT_EXCEL_FORMAT) {
        window.open(`/user/reports/excel/buyByMonth/${formData.providerId}/${startDate}/${endDate}`, "_blank")
      }
    }

    return (
      <>
        <DynamicForm<BuyReportFormDataType>
          ref={formRef}
          id="report"
          formConfig={getFormConfig()}
          onSubmit={generateForm}
        >
          <Row>
            <Col md={{
              offset: 2
            }}>
              <Button className="me-3" type="submit" color="primary" size="lg">Generar Report</Button>
            </Col>
          </Row>
        </DynamicForm>
      </>
    )
  }
);

export default BuyYearReportForm;